import * as types from 'store/modules/hres94u/mutation-types'
import hres94u from 'api/hres94u'
import swal from 'sweetalert'
import { sendApprove } from 'assets/js/sendApprove.js'
import hres94uLabels from 'assets/labels/hres94u'
import { hres94uColumns } from 'assets/columns/hres94u'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres94uLabels,
    columns: hres94uColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {}
    },
    indexSelected: []
  },
  getters: {
    [types.GET_HRES94U_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES94U_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES94U_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES94U_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES94U_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES94U_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES94U_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRES94U_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES94U_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES94U_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRES94U_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRES94U_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES94U_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES94U_DETAIL] (state, data) {
      state.detail = data
    }
  },
  actions: {
    [types.TOGGLE_HRES94U_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES94U_INDEX_DISP, indexDisp)
      commit(types.SET_HRES94U_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES94U_COLUMNS_LABELS] ({ commit }) {
      hres94u.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES94U_COLUMNS, data.labels)
          commit(types.SET_HRES94U_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES94U_INDEX] ({ commit }, searchParams) {
      hres94u.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES94U_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES94U_DETAIL] ({ commit }, searchParams) {
      hres94u.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES94U_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES94U_SEND_APPROVE] ({ commit, dispatch }, indexRows) {
      sendApprove({
        dataRows: indexRows,
        sendApprove: hres94u.postSendApprove,
        dispatch: dispatch,
        dispatchType: types.RECEIVED_HRES94U_INDEX
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres94u/index.js